'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Copyright 2019 Adobe Inc. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  you may not use this file except in compliance with the License. You may obtain a copy
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  of the License at http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Unless required by applicable law or agreed to in writing, software distributed under
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  OF ANY KIND, either express or implied. See the License for the specific language
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  governing permissions and limitations under the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _WAMConnectionManager = require('./WAMConnectionManager');

var _WAMConnectionManager2 = _interopRequireDefault(_WAMConnectionManager);

var _WAMMessageManager = require('./WAMMessageManager');

var _WAMMessageManager2 = _interopRequireDefault(_WAMMessageManager);

var _WAMConstants = require('./constants/WAMConstants');

var _ThorDetectUtil = require('./util/ThorDetectUtil');

var _ThorDetectUtil2 = _interopRequireDefault(_ThorDetectUtil);

var _WAMErrors = require('./errors/WAMErrors');

var _GlobalData = require('./util/GlobalData');

var _GlobalData2 = _interopRequireDefault(_GlobalData);

var _AnalyticsUtil = require('./util/AnalyticsUtil');

var _AnalyticsUtil2 = _interopRequireDefault(_AnalyticsUtil);

var _CommonUtil = require('./util/CommonUtil');

var _CommonUtil2 = _interopRequireDefault(_CommonUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WAMUtil = function () {

	// Singleton
	function WAMUtil() {
		_classCallCheck(this, WAMUtil);

		if (this.instance) {
			return this.instance;
		}
		this.instance = this;
		this.environment = null;
		this.didExitFromWAMWorkFlow = false;
		this.initThorConnectionInProgress = false;
	}

	/** To add Listener when ClientMsg arrives **/


	_createClass(WAMUtil, [{
		key: 'addListenerForClientMsg',
		value: function addListenerForClientMsg(clientMsgHandler) {
			this.clientMsgHandlers = this.clientMsgHandlers || [];
			this.clientMsgHandlers.push(clientMsgHandler);
		}

		/** To add Listener when ClientMsg arrives **/

	}, {
		key: 'removeListenerForClientMsg',
		value: function removeListenerForClientMsg(clientMsgHandler) {
			var _this = this;

			this.clientMsgHandlers && this.clientMsgHandlers.forEach(function (handler, index) {
				if (clientMsgHandler === handler) {
					_this.clientMsgHandlers.splice(index, 1);
				}
			});
		}

		/** To add Listener when ClientState arrives **/

	}, {
		key: 'addListenerForClientState',
		value: function addListenerForClientState(clientStateHandler) {
			this.clientStateHandlers = this.clientStateHandlers || [];
			this.clientStateHandlers.push(clientStateHandler);
		}

		/** To add Listener when ClientState arrives **/

	}, {
		key: 'removeListenerForClientState',
		value: function removeListenerForClientState(clientStateHandler) {
			var _this2 = this;

			this.clientStateHandlers && this.clientStateHandlers.forEach(function (handler, index) {
				if (clientStateHandler === handler) {
					_this2.clientStateHandlers.splice(index, 1);
				}
			});
		}

		// To return product list from Thor

	}, {
		key: 'getThorApps',
		value: function getThorApps() {
			return _WAMMessageManager2.default.products;
		}

		// To return apps panel status from Thor

	}, {
		key: 'getThorAppsPanelStatus',
		value: function getThorAppsPanelStatus() {
			return _WAMMessageManager2.default.thorAppsPanelStatus;
		}

		// To check if Thor apps panel is loaded

	}, {
		key: 'isThorAppsPanelLoaded',
		value: function isThorAppsPanelLoaded() {
			return this.isThorAppsPanelEnabled() && _WAMMessageManager2.default.thorAppsPanelStatus === _WAMConstants.wamMsgStatusType.thorAppsState.loaded;
		}

		// To check if Thos apps panel is still loading

	}, {
		key: 'isThorAppsPanelLoading',
		value: function isThorAppsPanelLoading() {
			return this.isThorAppsPanelEnabled() && (_WAMMessageManager2.default.thorAppsPanelStatus === _WAMConstants.wamMsgStatusType.thorAppsState.appRefreshedStarted || _WAMMessageManager2.default.thorAppsPanelStatus === _WAMConstants.wamMsgStatusType.thorAppsState.loading);
		}

		// To check if Thor product list is present

	}, {
		key: 'isThorAppListPresent',
		value: function isThorAppListPresent() {
			return this.isThorAppsPanelEnabled() && _WAMMessageManager2.default.products !== null;
		}
	}, {
		key: 'isThorAppsPanelEnabled',
		value: function isThorAppsPanelEnabled() {
			if (_WAMMessageManager2.default.appsPanelHidden === null) {
				// To support Inline workflow with Thor release prior to 4.7
				return true;
			}
			return _WAMMessageManager2.default.appsPanelHidden === 'false'; // appsPanelHidden should be equal to false
		}

		// To verify that CCH is ready to receive message and Thor apps panel is loaded

	}, {
		key: 'areClientsConnected',
		value: function areClientsConnected() {
			return _WAMConnectionManager2.default.isCCHReadyToRecvData() && this.isThorAppsPanelLoaded();
		}

		// To verify that CCH is ready to receive message and Thor apps panel is loaded or loading

	}, {
		key: 'areClientsConnectedOrAppsPanelLoading',
		value: function areClientsConnectedOrAppsPanelLoading() {
			return _WAMConnectionManager2.default.isCCHReadyToRecvData() && (this.isThorAppsPanelLoaded() || this.isThorAppsPanelLoading());
		}

		// To fetch Prodct from Thor product list and from FFC product list based on sapcode and version.

	}, {
		key: 'getAppFromThorAndFFC',
		value: function getAppFromThorAndFFC(thorAppsList, ffcAppsList, sapcode) {
			var productFromFFC = void 0;
			var productFromThor = void 0;
			if (sapcode && ffcAppsList) {
				productFromFFC = ffcAppsList[sapcode];
			}
			if (productFromFFC && thorAppsList) {
				productFromThor = _WAMMessageManager2.default.getProduct(thorAppsList, productFromFFC.id, productFromFFC.version);
			}
			return { productFromFFC: productFromFFC, productFromThor: productFromThor };
		}

		/**
   *
   * @param logData
   */

	}, {
		key: 'printLog',
		value: function printLog(logData) {
			if (_GlobalData2.default.isLoggingEnabled) {
				console.log(logData);
			}
		}

		// To append source type in error description which will sent in analytics

	}, {
		key: 'appendSourceInDesc',
		value: function appendSourceInDesc(desc) {
			if (_WAMConnectionManager2.default.sourceType) {
				return desc + ' | source: ' + _WAMConnectionManager2.default.sourceType;
			}
			return desc;
		}

		// To verify if Product From Thor is in error state, i.e last executed opetation (install, uninstall or update) didn't succeeded

	}, {
		key: 'isProductInErrorState',
		value: function isProductInErrorState(productFromThor) {
			return productFromThor && (productFromThor.showRetryBtn || productFromThor.error_details && productFromThor.error_details.error_code || productFromThor.status === _WAMConstants.wamMsgStatusType.appUnknown);
		}

		// To verify if product is installed

	}, {
		key: 'isProductInstalled',
		value: function isProductInstalled(productFromThor) {
			return productFromThor && (productFromThor.stateCategory === _WAMConstants.thorAppsStatesCategory.availableToUpdate || productFromThor.stateCategory === _WAMConstants.thorAppsStatesCategory.installed);
		}

		// To verify if access Token is valid and refresh the page if it's not

	}, {
		key: 'isTokenValid',
		value: function isTokenValid() {
			if (_GlobalData2.default.callbacks.clientTokenExpiryCheck) {
				var tokenStatus = _GlobalData2.default.callbacks.clientTokenExpiryCheck();
				if (typeof tokenStatus !== 'undefined' && tokenStatus !== null) {
					return tokenStatus;
				}
			}
			return true;
		}
	}, {
		key: 'shouldSendAnalytics',
		value: function shouldSendAnalytics(wamConfig) {
			return wamConfig.sendAnalytics;
		}
	}, {
		key: 'sendAnalyticsOnTimeout',
		value: function sendAnalyticsOnTimeout(wamConfig) {
			if (_WAMConnectionManager2.default.doesThorSupportInline) {
				// To make sure Thor was ready to support Inline
				var isCurrentDeviceFound = _WAMConnectionManager2.default.currentDevice && _WAMConnectionManager2.default.currentDevice.deviceId;
				var isThorAppsPanelLoaded = this.areClientsConnected();
				var isCCHRegistered = _WAMConnectionManager2.default.isCCHomeRegistered;
				!_GlobalData2.default.thorConnection.error && (_GlobalData2.default.thorConnection.error = _WAMErrors.thorConnection.errors.thorConnectionTimeout);
				if (!isThorAppsPanelLoaded) {
					if (!_WAMConnectionManager2.default.wamConnectionAnalyticsParams.recvThorAppsState) {
						// To make sure the event pertaining to Thor apps state has not been sent in the same execution
						var errorDesc = this.appendSourceInDesc('timeout on client side. Apps state:' + _WAMMessageManager2.default.thorAppsPanelStatus + '. Current Device ' + (isCurrentDeviceFound ? 'received' : 'not received') + '. CCH ' + (isCCHRegistered ? 'registered' : 'not registered'));
						this.printLog(errorDesc);
						this.shouldSendAnalytics(wamConfig) && _AnalyticsUtil2.default.sendAnalytics({ eventName: _WAMConstants.analyticsEvents.onClientRecvThorAppsState, status: false, errorType: 'timeout', errorDesc: errorDesc });
						_WAMConnectionManager2.default.wamConnectionAnalyticsParams.recvThorAppsState = 'timeout';
					}
				}
				if (!isCurrentDeviceFound) {
					if (!_WAMConnectionManager2.default.wamConnectionAnalyticsParams.recvDeviceId) {
						// To make sure the event pertaining to current device has not been sent in the same execution
						var _errorDesc = this.appendSourceInDesc('timeout on client side for receive current device');
						this.printLog(_errorDesc);
						this.shouldSendAnalytics(wamConfig) && _AnalyticsUtil2.default.sendAnalytics({ eventName: _WAMConstants.analyticsEvents.onReceiveCurrentDevice, status: false, errorType: 'timeout', errorDesc: _errorDesc });
					}
				}
				if (!isCCHRegistered) {
					if (!_WAMConnectionManager2.default.wamConnectionAnalyticsParams.ccHRegistered) {
						// To make sure the event pertaining to CCH registration has not been sent in the same execution
						var _errorDesc2 = this.appendSourceInDesc('timeout on client side for CCH registration');
						this.printLog(_errorDesc2);
						this.shouldSendAnalytics(wamConfig) && _AnalyticsUtil2.default.sendAnalytics({ eventName: _WAMConstants.analyticsEvents.onClientRegistratonWithWAM, status: false, errorType: 'timeout', errorDesc: _errorDesc2 });
					}
				}
			} else {
				this.shouldSendAnalytics(wamConfig) && _AnalyticsUtil2.default.sendAnalyticsOnCCDFailedWAM();
				this.printLog('Thor is not supporting inline');
			}
		}
	}, {
		key: 'exitFromWamWorkflow',
		value: function exitFromWamWorkflow(wamConfig) {
			this.printLog('Exiting from WAM Workflow');
			this.didExitFromWAMWorkFlow = true;
			this.sendAnalyticsOnTimeout(wamConfig);
		}
	}, {
		key: 'iniThorConnectionForWAM',
		value: function iniThorConnectionForWAM(wamConfig) {
			var _this3 = this;

			var promiseArray = [];
			var isLongWaitingEnabled = true;
			if (wamConfig.isLongWaitingEnabled !== undefined) {
				isLongWaitingEnabled = wamConfig.isLongWaitingEnabled;
			}
			var isTokenValid = this.isTokenValid();
			var ispromiseToResolveAppsStateComplete = void 0;
			if (isTokenValid && !this.initThorConnectionInProgress && !this.didExitFromWAMWorkFlow) {
				this.initThorConnectionInProgress = true;
				ispromiseToResolveAppsStateComplete = false;
				var promiseToResolveAppsStateFromThor = new Promise(function (resolve) {
					if (_this3.areClientsConnectedOrAppsPanelLoading()) {
						_this3.printLog('CCH and Thor are connected or Thor apps panel is loading');
						resolve(true);
						return;
					}
					_this3.printLog('CCH and Thor are not connected, hence destroying the current socket');
					_WAMConnectionManager2.default.destroySocket();
					_WAMConnectionManager2.default.init(isLongWaitingEnabled).then(function (isConnectedWithWAM) {
						return resolve(isConnectedWithWAM);
					});
				}).then(function (connected) {
					if (connected) {
						if (_this3.areClientsConnectedOrAppsPanelLoading()) {
							_this3.printLog('CCH and Thor are already connected');
							return connected;
						}
						_this3.printLog('Sending WAM event true');
						_AnalyticsUtil2.default.sendAnalytics({ eventName: _WAMConstants.analyticsEvents.onClientWAMConnection, status: true });
						_WAMConnectionManager2.default.reset();
						if (wamConfig.pingType === _WAMConstants.pingType.http) {
							return _WAMConnectionManager2.default.httpPingFetchAppsStateAndRegisterCCH(isLongWaitingEnabled, wamConfig);
						}
						return _WAMConnectionManager2.default.fetchAppsStateAndRegisterCCH(isLongWaitingEnabled, wamConfig);
					}
					_this3.printLog('Connection with WAM couldn\'t be established');
					return false;
				}).then(function (ccHomeAndThorConnectionStatus) {
					if (ispromiseToResolveAppsStateComplete === false) {
						// To verify this execution started the call to fetch apps state
						_this3.printLog('' + (ccHomeAndThorConnectionStatus ? 'Connection established' : 'Connection could not established'));
						_this3.initThorConnectionInProgress = false;
						ispromiseToResolveAppsStateComplete = true;
						if (!ccHomeAndThorConnectionStatus) {
							_this3.exitFromWamWorkflow(wamConfig);
							_WAMConnectionManager2.default.destroySocket();
						}
					}
					return ccHomeAndThorConnectionStatus;
				}).catch(function () {
					if (ispromiseToResolveAppsStateComplete === false) {
						// To verify this execution started the call to fetch apps state
						_this3.printLog('Connection could not established');
						_this3.initThorConnectionInProgress = false;
						ispromiseToResolveAppsStateComplete = true;
						_this3.exitFromWamWorkflow(wamConfig);
						_WAMConnectionManager2.default.destroySocket();
					}
					return false;
				});
				promiseArray.push(promiseToResolveAppsStateFromThor);
			}

			if (!isLongWaitingEnabled && wamConfig.timeout) {
				var timeoutPromise = new Promise(function (resolve) {
					setTimeout(function () {
						if (ispromiseToResolveAppsStateComplete === false) {
							// To verify this execution started the call to fetch apps state
							ispromiseToResolveAppsStateComplete = true;
							_this3.printLog('Timeout occurs');
							_this3.sendAnalyticsOnTimeout(wamConfig);
							_this3.initThorConnectionInProgress = false;
						}

						if (_this3.areClientsConnected()) {
							resolve(true);
							return;
						}
						if (wamConfig.disconnectConn) {
							_this3.didExitFromWAMWorkFlow = true;
							_WAMConnectionManager2.default.destroySocket();
						}
						resolve(false);
					}, wamConfig.timeout);
				});
				promiseArray.push(timeoutPromise);
			}

			if (promiseArray.length === 0) {
				promiseArray.push(new Promise(function (resolve) {
					return resolve(false);
				}));
			}
			return Promise.race(promiseArray);
		}
	}, {
		key: 'shouldRefreshCCHOnThorDetection',
		value: function shouldRefreshCCHOnThorDetection(isThorPresentForInline, wamConfig) {
			var _this4 = this;

			if (!isThorPresentForInline && wamConfig.retryWAMConnection) {
				if (!this.tryForInlineCTAFun) {
					this.tryForInlineCTACount = 0;
					wamConfig.sendAnalytics = false;
					this.tryForInlineCTAFun = setInterval(function () {
						_this4.didExitFromWAMWorkFlow = false;
						_this4.iniThorConnectionForWAM(wamConfig).then(function (isThorPresentForInline) {
							if (isThorPresentForInline) {
								clearInterval(_this4.tryForInlineCTAFun);
							} else {
								_this4.tryForInlineCTACount++;
								if (_this4.tryForInlineCTACount >= _WAMConstants.inlineAttemptThroughFirstTimeInstall.iterations) {
									clearInterval(_this4.tryForInlineCTAFun);
								}
							}
						});
					}, _WAMConstants.inlineAttemptThroughFirstTimeInstall.interval);
				}
			}
		}
	}, {
		key: 'triggerCCDByPingType',
		value: function triggerCCDByPingType(wamConfig, pingType, resolve) {
			var _this5 = this;

			if (wamConfig.sendAnalytics === undefined) {
				wamConfig.sendAnalytics = true;
			}
			wamConfig.pingType = pingType;
			this.iniThorConnectionForWAM(wamConfig).then(function (isThorPresentForInline) {
				resolve(isThorPresentForInline);
				_this5.shouldRefreshCCHOnThorDetection(isThorPresentForInline, wamConfig);
			});
		}
		// For LocalThor detection. It will also fetch current device and apps state from Thor.

	}, {
		key: 'initThorConnection',
		value: function initThorConnection(wamConfig) {
			var _this6 = this;

			this.printLog(wamConfig);
			_GlobalData2.default.thorConnection = {};

			return new Promise(function (resolve) {

				if (_this6.areClientsConnected()) {
					resolve(true);
					return;
				}
				_GlobalData2.default.ccdDetectPromise && _GlobalData2.default.ccdDetectPromise.then(function (isCCDPresent) {
					if (!isCCDPresent) {
						_this6.exitFromWamWorkflow(wamConfig);
						_GlobalData2.default.thorConnection.error = _WAMErrors.thorConnection.errors.thorNotPresent;
						resolve(false);
						return;
					}
					var httpPingSupportedInBrowser = _CommonUtil2.default.isBrowserSupportedForHttpPing();
					var isDeprecatedOSForCCDHttpPing = _CommonUtil2.default.isDeprecatedOSForCCDHttpPing();
					if (_GlobalData2.default.shouldTryHttpPing && httpPingSupportedInBrowser && !isDeprecatedOSForCCDHttpPing) {
						// http ping workflow
						// Browser supports http ping
						var wamArgs = { pingType: _WAMConstants.pingType.httpPing, version: _WAMConstants.wamConnectWF.v2 };
						// Checking if Thor supports http ping
						_ThorDetectUtil2.default.checkForThor(wamArgs).then(function (isHttpPingSupported) {
							if (isHttpPingSupported) {
								_AnalyticsUtil2.default.sendAnalytics({ eventName: _WAMConstants.analyticsEvents.v1ToV2, workflow: _WAMConstants.wamConnectWF.v2, subType: 'v2-workflow' });
								_this6.triggerCCDByPingType(wamConfig, _WAMConstants.pingType.http, resolve);
							} else {
								// http ping is not supported in thor hence falling back to https
								_AnalyticsUtil2.default.sendAnalytics({ eventName: _WAMConstants.analyticsEvents.v2ToV1, workflow: _WAMConstants.wamConnectWF.v1, subType: 'thor-incompatible' });
								_this6.triggerCCDByPingType(wamConfig, _WAMConstants.pingType.https, resolve);
							}
						});
					} else {
						// Try https workflow if http ping is not needed or browser/CCD doesn't support
						if (!httpPingSupportedInBrowser) {
							// Check for http ping support in browser and fallback to https if it doesn't
							_AnalyticsUtil2.default.sendAnalytics({ eventName: _WAMConstants.analyticsEvents.v2ToV1, workflow: _WAMConstants.wamConnectWF.v1, subType: 'browser-incompatible' });
						}
						if (isDeprecatedOSForCCDHttpPing) {
							_AnalyticsUtil2.default.sendAnalytics({ eventName: _WAMConstants.analyticsEvents.v2ToV1, workflow: _WAMConstants.wamConnectWF.v1, subType: 'os-incompatible' });
						}
						_this6.triggerCCDByPingType(wamConfig, _WAMConstants.pingType.https, resolve);
					}
				});
			});
		}
	}]);

	return WAMUtil;
}();

exports.default = new WAMUtil();